import {
  RESET_SEARCH_STATE,
  SET_DATE_RANGE,
  SET_EDITING_FILTER,
  SET_FILTERS,
  SET_SHORT_TIME_INTERVAL,
  SET_WHITELISTED_SEGMENT_IDS,
  TOGGLE_IS_ADDING_FILTER,
} from './constants';

import { Filter } from '../types';

export const resetSearchState = () => ({ type: RESET_SEARCH_STATE });
export const setToggleIsAddingFilter = () => ({
  type: TOGGLE_IS_ADDING_FILTER,
});
export const setEditingFilter = (editingFilter?: Filter) => ({
  type: SET_EDITING_FILTER,
  editingFilter,
});
export const setFilters = (filters: Filter[]) => ({ type: SET_FILTERS, filters });

export const setShortTimeInterval = (shortTimeInterval: string) => ({
  type: SET_SHORT_TIME_INTERVAL,
  shortTimeInterval,
});

export const setDateRange = (dateRange: any) => ({
  type: SET_DATE_RANGE,
  dateRange,
});

export const setWhitelistedSegmentIds = (whitelistedSegmentIds?: string[]) => ({
  type: SET_WHITELISTED_SEGMENT_IDS,
  whitelistedSegmentIds,
});
